import { insertTrackEvent } from '@comeon/analytics';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectPlayerBonusBlocked } from '~/components/account/ducks';
import { authenticationSelector } from '~/components/authentication/ducks/selectors.js';
import { FilterLink, StyledExternalLink } from '~/components/header/filters.js';
import { fetchPromotionsAvailability } from '~/components/promotions/ducks/promotions-duck.js';
import { selectPromotionsIsAvailableForUser } from '~/components/promotions/ducks/selectors';

const PromotionItem = ({ label, href, onClick, oldEnough, isSelfExcluded }) => {
	const dispatch = useDispatch();
	const promotionsAvailableForUser = useSelector(selectPromotionsIsAvailableForUser);
	const authenticated = useSelector(authenticationSelector);
	const isPlayerBonusBlocked = useSelector(selectPlayerBonusBlocked);

	useEffect(() => {
		if (authenticated) {
			dispatch(fetchPromotionsAvailability());
		}
	}, [authenticated, isSelfExcluded, dispatch]);

	if (promotionsAvailableForUser || !authenticated) {
		if (oldEnough && !isSelfExcluded)
			return (
				<FilterLink
					alignitemright
					href={href}
					data-at="promotions"
					onClick={() => insertTrackEvent({ category: 'Top Nav Item', action: 'Click', label: 'promotions' })}
				>
					{label}
				</FilterLink>
			);
		if (isSelfExcluded && isPlayerBonusBlocked) {
			return null;
		}
		return (
			<StyledExternalLink data-at="promotions" onClick={() => onClick()}>
				{label}
			</StyledExternalLink>
		);
	}

	return null;
};

export default PromotionItem;
